import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";

import { type Expense } from "@/hooks/useExpenses";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import ExpenseRow from "@/components/v2/molecules/admin/tabs/AdminExpensesTab/ExpenseRow";

interface ExpensesTableProps {
  expenses: Expense[];
  onViewReceipt: (url: string) => void;
  onEdit: (expense: Expense) => void;
  onDelete: (expense: Expense) => void;
  canEdit: boolean;
  canDelete: boolean;
  selectedExpenses: string[];
  onSelectExpense: (expenseId: string, index: number, shiftKey: boolean) => void;
  onSelectAll: (checked: boolean) => void;
}

const ExpensesTable = ({
  expenses,
  onViewReceipt,
  onEdit,
  onDelete,
  canEdit,
  canDelete,
  selectedExpenses,
  onSelectExpense,
  onSelectAll,
}: ExpensesTableProps) => {
  const showActions = canEdit || canDelete;
  const allSelected = expenses.length > 0 && selectedExpenses.length === expenses.length;
  const someSelected = selectedExpenses.length > 0 && selectedExpenses.length < expenses.length;

  const handleSelectAll = (checked: boolean) => {
    onSelectAll(checked);
  };

  const tableHeaders = [
    "",
    "Fecha de Pago",
    "Propiedad",
    "Categoría",
    "Subcategoría",
    "Descripción",
    "Monto",
    "Estatus",
    "Forma de Pago",
    "Etiqueta",
    "Comprobante",
    ...(showActions ? ["Acciones"] : []),
  ];

  return (
    <Card>
      <div className="overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {tableHeaders.map((header, index) => (
                <TableHead key={index}>
                  {index === 0 ? (
                    <Checkbox
                      checked={allSelected}
                      onCheckedChange={handleSelectAll}
                      aria-label="Seleccionar todos"
                      className={someSelected ? "data-[state=checked]:bg-primary/80" : ""}
                    />
                  ) : (
                    header
                  )}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
            {expenses && expenses.length > 0 ? (
              expenses.map((expense, index) => (
                <ExpenseRow
                  key={expense.id}
                  expense={expense}
                  index={index}
                  onViewReceipt={onViewReceipt}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  canEdit={canEdit}
                  canDelete={canDelete}
                  isSelected={selectedExpenses.includes(expense.id)}
                  onSelect={onSelectExpense}
                />
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={tableHeaders.length}
                  className="text-center py-8 text-muted-foreground"
                >
                  No hay gastos registrados
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};

export default ExpensesTable;
